import { Component, OnInit, ViewChild } from '@angular/core';
import { getFirebaseBackend } from '../../../app/authUtils';
import { OldDataService } from 'src/app/core/services/old-data.service';
import {
	NgbDate,
	NgbCalendar,
	NgbDateParserFormatter,
	NgbModal,
	ModalDismissReasons,
} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RescheduleService } from '../../services/rescheduled/reschedule.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { RESCHEDULE_THEADS } from 'src/app/shared/constants';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
	selector: 'app-reschedule-leads',
	templateUrl: './reschedule-leads.component.html',
	styleUrls: ['./reschedule-leads.component.scss'],
})
export class RescheduleLeadsComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent

	columnMode = ColumnMode;
	pendigRescheduleLeads = [];
	leads = [];
	columns: any[];
	temp = [];
	title = {
		text: 'Pending Reschedules',
		class: 'bg-secondary'
	}


	//New Attributes
	public user;
	public modules = [];
	public selectedStatus = 'Pending';
	public showingLeads = [];
	public loading = false;
	showInactiveCampaigns = false;

	//Range of Dates
	public hoveredDate: NgbDate | null = null;
	public fromDate: NgbDate | null;
	public toDate: NgbDate | null;

	public newTime;

	//Reschedule Request

	public premiumReschedule_leads: any = [];
	public rescheduleLeadStatus = 'Pending';

	public pendingRes: any = [];
	public approvedRes: any = [];
	public deniedRes: any = [];

	public notification = {
		mainNotify: false,
		blackoutdays: false,
		rescheduleLeads: false,
	};

	public closeResult;
	public fechaApprove: NgbDate;
	public hourApprove: string = '09';
	public minApprove: string = '00';
	public amPm: string = 'AM';
	public selectedResLead;

	public listAsQC = false;

	public type: string;
	public allLeads = [];
	public leadsOld = [];
	public tableConfig = {
		tableClass: 'table-striped table-hover',
		theadClass: 'thead-dark',
		dblclickRows: true,
	};
	public changeColor = ['prospect_company', 'replacement_status'];

	public buttons = [];
	public theads = RESCHEDULE_THEADS;

	public counts: any;

	constructor(
		private dataService: OldDataService,
		public authenticationService: AuthenticationService,
		public utils: UtilsService,
		private modalService: NgbModal,
		private calendar: NgbCalendar,
		private sanitizer: DomSanitizer,
		public formatter: NgbDateParserFormatter,
		public router: Router,
		public rescheduleService: RescheduleService,
		private userSrv: UserService
	) {
		//Range Dates
		this.fromDate = calendar.getToday();
		this.fromDate = calendar.getPrev(calendar.getToday(), 'm', 1);
		this.toDate = calendar.getToday();

		this.type = 'Pending Reschedules';

		this.columns = [
			{
				name: 'Appt Date',
				prop: 'date_generated',
				showed: true
			},
			{
				name: 'Phone',
				prop: 'primary_phone',
				showed: true
			},
			{
				name: 'Prospect',
				prop: 'prospect_company',
				showed: true
			},
			{
				name: 'Campaign',
				prop: 'campaign_name',
				showed: true
			}
		];
	}

	ngOnInit() {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.user.modules = { full_reschedule: false };
		this.getPendingReschedulesLeads();
		this.getCounts();

		// this.userSrv.getUserModules(this.user.IdUser).subscribe((data: any)=>{
		// 	this.user.modules = data.body;
		// 	if (!this.user.modules.full_reschedule) {
		// 		this.listAsQC = true;
		// 		this.getListAsQC();
		// 		this.getCounts();
		// 	}
		// });
	}

	openApproveModal(content, resLead) {
		this.selectedResLead = resLead;
		this.modalService
			.open(content, {
				ariaLabelledBy: 'modal-basic-title',
				centered: true,
			})
			.result.then(
				(result) => {
					this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					this.closeResult = `Dismissed ${this.getDismissReason(
						reason,
					)}`;
				},
			);
	}

	getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	changeOfStatus(status: string) {
		this.selectedStatus = status;
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate &&
			!this.toDate &&
			this.hoveredDate &&
			date.after(this.fromDate) &&
			date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return (
			this.toDate && date.after(this.fromDate) && date.before(this.toDate)
		);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

	validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed))
			? NgbDate.from(parsed)
			: currentValue;
	}

	getPendingReschedulesLeads() {
		this.title.text = 'Pending Reschedule Leads';
		this.title.class = 'bg-danger';
		this.loading = true;
		this.rescheduleService.getPendingReschedules().subscribe((data: any)=>{
			this.leads = data.body;
			this.hideInactiveCampaignsLeads();
			this.loading = false;
		})
	}

	editLead(lead: any) {
		this.router.navigateByUrl('/lead-edit/' + lead.lead_id);
	}

	changeRequests() {
		if (this.type === 'Pending Reschedules') {
			this.type = 'Reschedules Requests';
			this.getRescheduleRequests();
		} else if (this.type === 'Reschedules Requests') {
			this.type = 'Pending Reschedules';
			// this.getListAsQC();
		}
	}

	getRescheduleRequests() {
		this.title.text = 'Reschedule Requests';
		this.title.class = 'bg-warning';
		this.loading = true;
		this.rescheduleService.getRescheduleRequests().subscribe((data: any)=>{
			this.leads = data.body;
			this.hideInactiveCampaignsLeads();
			this.loading = false;
		})
	}

	getCounts() {
		this.rescheduleService.getCounts().subscribe((data:any)=>{
			this.counts = data.body;
		});
	}

	getTodaySolvedReschedules() {
		this.title.text = 'Today Solved Pending Reschedules';

		this.rescheduleService.getTodaySolved().subscribe((data: any)=>{
			this.leadsOld = [];
				for (let lead of data.body) {
					if (
						lead.replacement_status != '' ||
						lead.replacement_status != null
					) {
						switch (lead.replacement_status) {
							case 'Approved':
								lead.class = {
									class: 'bg-success',
									key: 'prospect_company',
								};
								break;
							case 'Replaced':
								lead.class = {
									class: 'bg-purple',
									key: 'prospect_company',
								};
								break;
							case 'Rescheduled':
								lead.class = {
									class: 'bg-grey-dark',
									key: 'prospect_company',
								};
								break;
							case 'Pending Replacement':
								lead.class = {
									class: 'bg-purple-light',
									key: 'prospect_company',
								};
								break;
							case 'Pending Reschedule':
								lead.class = {
									class: 'bg-grey-light',
									key: 'prospect_company',
								};
								break;
							case 'QC Calls':
								lead.class = {
									class: 'bg-oliva',
									key: 'prospect_company',
								};
								break;
							default:
								lead.class = {
									class: 'bg-success',
									key: 'prospect_company',
								};
								break;
						}
					}

					if (lead.campaign_active == '1') {
						lead.campaign_name =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="fa fa-check" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
							);
					} else {
						lead.campaign_name =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="fa fa-ban" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
							);
					}
					this.leadsOld.push(lead);
				}
		});
	}

	showHideColumns(columnProp){
		const obj = this.columns.find(column=>{
			return column.prop === columnProp;
		});
		return obj.showed;
	}

	toogleShowInactiveCampaigns(){
		if(this.showInactiveCampaigns){
			this.hideInactiveCampaignsLeads();
			this.showInactiveCampaigns = false;
		} else {
			this.showInactiveCampaigns = true;
			this.showInactiveCampaignsLeads();
		}
	}

	hideInactiveCampaignsLeads(){
		this.pendigRescheduleLeads = this.leads.filter(lead=>{
			return lead.campaign_active == 1;
		});
		this.temp = [...this.pendigRescheduleLeads];
	}

	showInactiveCampaignsLeads(){
		this.pendigRescheduleLeads = this.leads;
		this.temp = [...this.pendigRescheduleLeads];
	}


	searchNgxDatatable(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data

		const temp = this.temp.filter(function (d) {
			// Verifica si alguna de las propiedades contiene el valor buscado
			return propArray.some(prop => {
				return d[prop].toString().toLowerCase().indexOf(val) != -1 || !val;
			});
		});

		// update the rows
		this.pendigRescheduleLeads = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}
}
